(() => {
  angular
    .module('gm.common.currency')
    .factory('GmyCurrencies', GmyCurrencies);

  function GmyCurrencies(
    $rootScope,
    btgUser,
    GmyStorage,
    Continents,
    Currencies
  ) {
    'ngInject';

    const PROPERTIES_CURRENCY_KEY = 'currency';
    const LOCALSTORAGE_CURRENCY_KEY = 'selectedCurrency';
    const TAX_CURRENCY_KEY = 'taxCurrency';

    const allCurrencies = angular.copy(Currencies);
    const continents = angular.copy(Continents);
    const allCurrenciesHash = allCurrencies.reduce(hashReduce, {});

    let _currencyDetectionStarted = false;
    let _tempLivePriceCurrency = null;

    return {
      currencyExists,
      getCountriesByGroups,
      getCurrencies,
      getCurrenciesCodes,
      getCurrencyHash,
      getDecimals,
      getDefaultCurrency,
      getDefaultCurrencyCode,
      getFlags,
      getTaxCurrency,
      getTaxCurrencyCode,
      getTempLivePriceCurrency,
      getTopCountries,
      setDefaultCurrencyCode,
      setTaxCurrencyCode,
      setTempLivePriceCurrency,
      prepareCurrencyForMenu,
    };

    function currencyExists(currencyCode) {
      return angular.isDefined(getCurrencyHash()[currencyCode]);
    }

    function detectCurrencyByLocation() {
      if (_currencyDetectionStarted) {
        return;
      }

      _currencyDetectionStarted = true;

      const stopWatch = $rootScope.$watch('location.countryCode', (origCountryCode) => {
        if (origCountryCode) {
          const countryCode = origCountryCode.toLowerCase();

          const currency = getCurrencies()
            .find(c => c.countries && c.countries.some(country => country.flag === countryCode));

          if (currency) {
            setDefaultCurrencyCode(currency.code);
          }

          stopWatch();
        }
      }, true);
    }

    function getCountriesByGroups(filter, exclude) {
      return getCurrencies(filter, exclude).reduce((result, cur) => {
        if (cur.countries && cur.countries.length > 0) {
          const continentName = continents[cur.countries[0].continent];

          result[continentName] = result[continentName] || [];
          result[continentName].push(cur);
        }

        return result;
      }, {});
    }

    function getCurrencies(filter = false, exclude = false) {
      let filteredCurrencies = (filter || exclude)
        ? allCurrencies.filter(cur => (!filter || filter.indexOf(cur.code) !== -1)
          && (!exclude || exclude.indexOf(cur.code) === -1))
        : allCurrencies;

      filteredCurrencies = filteredCurrencies.filter((c) => {
        const isFilter = filter && filter.indexOf(c.code) > -1;

        return isFilter ? true : !c.isHidden;
      });
      filteredCurrencies.sort(sortCurrencies);

      return filteredCurrencies;
    }

    function getCurrenciesCodes(filter, exclude) {
      return getCurrencies(filter, exclude).map(c => c.code);
    }

    function getCurrencyHash(filter, exclude) {
      return (filter || exclude)
        ? getCurrencies(filter, exclude).reduce(hashReduce, {})
        : allCurrenciesHash;
    }

    function getDecimals(currency) {
      switch (currency) {
        case 'GAU':
          return 3;
        case 'BTC':
          return 6;
        default:
          return 2;
      }
    }

    function getDefaultCurrency(filter, exclude) {
      let propertyCode = btgUser.getProperty(PROPERTIES_CURRENCY_KEY)
        || GmyStorage.getLocalItem(LOCALSTORAGE_CURRENCY_KEY);

      if (!propertyCode) {
        detectCurrencyByLocation();
        propertyCode = 'USD';
      }

      if (!filter || filter.indexOf(propertyCode) !== -1) {
        const filteredHash = getCurrencyHash(filter, exclude);

        return filteredHash[propertyCode] ? filteredHash[propertyCode] : getCurrencyHash().USD;
      }

      return getCurrencies(filter, exclude)[0];
    }

    function getDefaultCurrencyCode(filter, exclude) {
      const currency = getDefaultCurrency(filter, exclude);

      return currency ? currency.code : null;
    }

    function getFlags(currency) {
      return getCurrencies().filter(c => c.code === currency).map(c => c.flag);
    }

    function getTaxCurrency() {
      return getCurrencyHash()[btgUser.getProperty(TAX_CURRENCY_KEY)] || null;
    }

    function getTaxCurrencyCode() {
      return getTaxCurrency() ? getTaxCurrency().code : null;
    }

    function getTempLivePriceCurrency() {
      return _tempLivePriceCurrency || getDefaultCurrency();
    }

    function getTopCountries(filter, exclude) {
      return getCurrencies(filter, exclude).filter(c => c.top > 0);
    }

    function hashReduce(hash, cur) {
      if (!hash[cur.code] || cur.top > 0) {
        hash[cur.code] = cur;
      }

      return hash;
    }

    function prepareCurrencyForMenu(currency) {
      return {
        id: currency.code,
        flag: currency.flag,
        name: currency.name,
        meat: currency.code,
        currency
      };
    }

    function setDefaultCurrencyCode(origCurrencyCode) {
      const currencyCode = (currencyExists(origCurrencyCode)) ? origCurrencyCode : 'USD';
      btgUser.setProperty(PROPERTIES_CURRENCY_KEY, currencyCode);
      GmyStorage.setLocalItem(LOCALSTORAGE_CURRENCY_KEY, currencyCode);
    }

    function setTaxCurrencyCode(currencyCode) {
      btgUser.setProperty(TAX_CURRENCY_KEY, currencyCode);
    }

    function setTempLivePriceCurrency(currency) {
      if (currency) {
        _tempLivePriceCurrency = (currencyExists(currency.code)) ? currency : getDefaultCurrency();
      } else {
        _tempLivePriceCurrency = null;
      }
    }

    function sortCurrencies(c1, c2) {
      if (c2.top || c1.top) {
        return (c2.top || 0) - (c1.top || 0);
      }

      return c2.name > c1.name ? -1 : 1;
    }
  }
})();
